import { Engine } from 'json-rules-engine';

export const loadRules = () => {
  
  const mockRules = [
    // { id: "1", ruleName: "Age Verification Rule" },
    // { id: "2", ruleName: "Purchase Eligibility Rule" },
  ];
  
  return {
    type: 'LOAD_RULES',
    payload: mockRules
  };
};

export const setCurrentRule = (rule) => {
  return {
    type: 'SET_CURRENT_RULE',
    payload: rule
  };
};

export const addRule = (ruleName) => {
  const newRule = {
    id: Date.now().toString(),
    ruleName,
    facts: [],
    decisions: []
  };
  
  return {
    type: 'ADD_RULE',
    payload: newRule
  };
};

export const addFact = (factData) => {
  const newFact = {
    id: Date.now().toString(),
    ...factData
  };
  
  return {
    type: 'ADD_FACT',
    payload: newFact
  };
};

export const updateFact = (factData) => {
  return {
    type: 'UPDATE_FACT',
    payload: factData
  };
};

export const deleteFact = (factId) => {
  return {
    type: 'DELETE_FACT',
    payload: factId
  };
};

export const addDecision = (decisionData) => {
  const newDecision = {
    id: Date.now().toString(),
    ...decisionData
  };
  
  return {
    type: 'ADD_DECISION',
    payload: newDecision
  };
};

export const updateDecision = (decision) => {
  return {
      type: 'UPDATE_DECISION',
      payload: decision
  };
};

export const deleteDecision = (decisionId) => {
  return {
    type: 'DELETE_DECISION',
    payload: decisionId
  };
};

export const validateRules = (factsToTest) => {
  return async (dispatch, getState) => {
      try {
          const { currentRule } = getState().JsonRulesEditorReducer;
          const engine = new Engine();
          
         
          if (currentRule.decisions && currentRule.decisions.length > 0) {
              currentRule.decisions.forEach(decision => {
                
                  console.log('Rule condition structure:', JSON.stringify(decision.condition, null, 2));
                  
               
                  const ruleConfig = {
                      conditions: decision.condition,
                      event: {
                          type: 'decision',
                          params: {
                              outcome: decision.Outcome
                          }
                      }
                  };
                  
                 
                  try {
                      engine.addRule(ruleConfig);
                  } catch (e) {
                      console.error('Error adding rule:', e);
                      console.error('Problem rule structure:', JSON.stringify(ruleConfig, null, 2));
                      throw e;
                  }
              });
              
             
              const results = await engine.run(factsToTest);
              console.log("Results:", results);
              
             
              const allEvents = [
                  ...(results.events || []), 
                  ...(results.failureEvents || [])
              ];
              
              dispatch({
                  type: 'SET_VALIDATION_RESULTS',
                  payload: {
                      events: allEvents,
                      success: results.events || [],
                      failure: results.failureEvents || [],
                      ruleResults: results.almanac?.ruleResults || []
                  }
              });
              
              return results;
          }
          return { events: [], failureEvents: [] };
      } catch (error) {
          console.error('Rule validation error:', error);
          
      
          dispatch({
              type: 'VALIDATION_ERROR',
              payload: error.message
          });
          
          return { events: [], failureEvents: [] };
      }
  };
};

export const generateRuleSet = () => {
  return (dispatch, getState) => {
    const { currentRule } = getState().JsonRulesEditorReducer;
    

    const ruleSet = {
      name: currentRule?.ruleName,
      rules: currentRule?.decisions?.map(decision => ({
        conditions: decision?.condition,
        event: {
          type: 'decision',
          params: {
            outcome: decision?.Outcome
          }
        }
      }))
    };
    
    dispatch({
      type: 'SET_GENERATED_RULESET',
      payload: ruleSet
    });
    
    return ruleSet;
  };
};

